import { castDraft, produce } from 'immer';

import State from '../core/State';
import PageInfo from '../entity/PageInfo';
import { ProjectForAllOfOrganizationFragment } from '../generated/graphql';
import initialState from '../initialState';

export const startFetchingLatestProjects = () => (state: State): State => {
  return produce(state, (draft) => {
    draft.latestProjects.fetching = state.latestProjects.fetching + 1;
  });
};

export const finishFetchingLatestProjects = () => (state: State): State => {
  return produce(state, (draft) => {
    draft.latestProjects.fetching = state.latestProjects.fetching - 1;
  });
};

export const setLatestProjects = (items: Array<ProjectForAllOfOrganizationFragment>, pageInfo: PageInfo) => (
  state: State,
): State => {
  return produce(state, (draft) => {
    draft.latestProjects.items = castDraft(items);
    draft.latestProjects.pageInfo = pageInfo;
  });
};

export const disposeLatestProjects = () => (state: State): State => {
  return produce(state, (draft) => {
    draft.latestProjects = castDraft(initialState.latestProjects);
  });
};

export const setHasDraftItems = (hasDraftItems: Array<string>) => (state: State): State => {
  return produce(state, (draft) => {
    draft.latestProjects.hasDraftItems = castDraft(hasDraftItems);
  });
};
